export default __webpack_public_path__ + "static/media/aboutus.90b5d4f2.jpg";